<div modalHeader class="header">
  <div class="d-flex justify-content-between px-3 py-2">
    <h2 class="modal-title font-weight-bold" [innerText]="title"></h2>
    <button type="button" class="close" aria-label="Close" tabindex="-1" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div modalContent class="modal-body">
  <p class="mb-0" [innerHtml]="message"></p>
</div>

<div modalFooter class="modal-footer">
  <button
    class="btn btn-light w-100"
    *ngIf="displayButton"
    [innerText]="buttonText"
    (click)="closedWithButtonClick()"
  ></button>
</div>
